var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentIconAmexColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.58 21H2.42A2.4 2.4 0 010 18.62V4.38A2.4 2.4 0 012.42 2h24.16A2.4 2.4 0 0129 4.38v14.25A2.4 2.4 0 0126.58 21z",
    fill: "#1D91CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.063 13.896L3.591 15H-.64l3.339-7h7.975l.805 1.546L12.231 8H22.983l.919.961.987-.961h4.993l-3.545 3.492L29.729 15h-4.832l-1.081-1.031L22.744 15H5.496l-.519-1.104",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98 13.97h-.92.92zM15.2 9h-2.1l-1.58 3.35L9.82 9h-2.1v4.85L5.55 9H3.58l-2.32 5h1.42l.47-1.14h2.7L6.39 14H9V9.93L10.85 14h1.22l1.84-4v4h1.29V9zm8.67 1.62L22.37 9h-6.02v5h5.82l1.65-1.64L25.48 14h1.55l-2.37-2.53L27.1 9h-1.62l-1.61 1.62zM20.7 13h-3.06v-1.1h3.06v-1h-3.06V10h3.06v-.85l2.27 2.27-2.27 2.28V13zM4.53 9.82l.88 2.03H3.58l.95-2.03z",
    fill: "#1D91CE"
  })));
}

export default SvgPaymentIconAmexColor;